import { INTERNAL_ERROR_CODE } from "@/shared/constants/http";

type ErrorWithCode = {
  code?: unknown;
};

export function isRequestCancellation(error: unknown, signal?: AbortSignal) {
  if (signal?.aborted) {
    return true;
  }

  if (error instanceof DOMException && error.name === "AbortError") {
    return true;
  }

  if (!error || typeof error !== "object") {
    return false;
  }

  const { code } = error as ErrorWithCode;

  return code === INTERNAL_ERROR_CODE.CANCELLED || code === "ERR_CANCELED";
}
